export default __webpack_public_path__ + "static/media/checked_form.8dc46d73.svg";